import React from 'react';
import Sidebar from './Sidebar';
import SuperadminViewBanner from './SuperadminViewBanner';
import './AppLayout.css';

type Props = { children: React.ReactNode };

const AppLayout: React.FC<Props> = ({ children }) => {
  return (
    <div className="bm-app">
      <Sidebar />
      <div className="bm-content">
        <SuperadminViewBanner />
        {children}
      </div>
    </div>
  );
};

export default AppLayout;


